<div class="d-flex align-items-center justify-content-between">
    <label class="filterLabelStyle" style="margin: 0 !important; z-index: 9;">{{ label || "Year Selection" }}</label>
    <div *ngIf="compulsaryFilterValidation()">
        <span mat-button style="cursor: pointer;font-size: 12px;font-family: 'Poppins';padding: 0 5px;    background: #ddd;
        border-radius: 5px;
        margin: 0 10px;" (click)="clearDateFilter()">Clear</span>
    </div>
</div>


<div class="my-1">
    <mat-form-field appearance="fill" style="width: 100%;" class="du-formly-yearly-selection">
      <mat-label style="font-family: 'Poppins';">Select Year</mat-label>
      <input matInput readonly [min]="minDate" [max]="maxDate" #DpInput [formControl]="selectedDate" [matDatepicker]="YearDp">
      <mat-datepicker-toggle matSuffix [for]="YearDp"></mat-datepicker-toggle>
      <mat-datepicker [calendarHeaderComponent]="exampleHeader" #YearDp (yearSelected)="yearSelected($event, YearDp)" startView="multi-year"></mat-datepicker>
    </mat-form-field>
</div>
<hr>